ACC.langcurrency = {

    _autoload: [
        'bindLangCurrencySelector',
    ],

    bindLangCurrencySelector() {
        $('#lang-selector').change(() => {
            $('#lang-form').submit();
        });

        $('#currency-selector').change(() => {
            $('#currency-form').submit();
        });
    },
};
